import type { Field, SectionComponentProps } from "../../types";
import Reference from "../../common/Reference";
import publishingInformation from "../references/publishing-information.png";
import Section from "../../common/Section/Section";
import { Stack } from "@mui/material";
import { getProjectUrlValue } from "../../../../formatting/domain-value-manipulation";

function Publishing({ details, onEdit }: SectionComponentProps) {
  const {
    id,
    isReadyForSale,
    notReadyForSaleReason,
    shortDescription,
    internalUseOnly,
  } = details;

  const publishingFields: Array<Field> = [
    {
      name: "Project Id",
      type: "text",
      index: 1,
      value: id,
    },
    {
      name: "Ready to go live?",
      type: "isReadyForSale",
      index: 0,
      value: isReadyForSale,
      notReadyForSaleReason,
      fullLine: true,
    },
    {
      name: "Website Url",
      type: "text",
      index: 2,
      value: getProjectUrlValue(internalUseOnly?.websiteUrl),
    },
  ];
  const introFields: Array<Field> = [
    {
      name: "Short Introduction",
      type: "text",
      index: 3,
      fullLine: true,
      value: shortDescription,
    },
  ];

  return (
    <Stack>
      <Section
        title="Publishing summary"
        columns={2}
        fields={publishingFields}
        onEdit={() => onEdit("publishing-summary")}
      />
      <Section
        title="Project introduction"
        columns={1}
        fields={introFields}
        onEdit={() => onEdit("project-introduction")}
        reference={[
          {
            type: "image",
            place: "beneath",
            index: 0,
            item: (
              <Reference
                image={publishingInformation}
                alt="Earthly publishing summary reference"
                testId="publishing-summary-reference"
              />
            ),
          },
        ]}
      />
    </Stack>
  );
}

export default Publishing;
